var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Hero',{attrs:{"title":"Faça parte da transformação <br /> do mundo Fitness","image":'home-banner.png',"search":true}}),_c('Brands'),_c('Job'),_c('WayOfBeing'),_c('WorkHere'),_c('Faq')],1)}
var staticRenderFns = []

export { render, staticRenderFns }